"use client";

import { FC, useState } from "react";

import { useStyles } from "./styles";
import { QuizType } from "@/types/quiz";
import {
  getScorePercentage,
  getScoreThumbnail,
} from "../QuestionAnswerScorecard/helpers";
import SpotifyWidget from "../SpotifyWidget";
import Watermark from "@/components/common/Watermark";

interface QuizResultThumbnailProps {
  title: string;
  description: string;
  thumbnail: string | null;
  quizType: QuizType;
  spotifyUrl: string | null;
  isBusiness?: boolean;
  productPageUrl?: string;
}

const QuizResultThumbnail: FC<QuizResultThumbnailProps> = ({
  title,
  description,
  thumbnail,
  quizType,
  spotifyUrl,
  isBusiness,
  productPageUrl,
}) => {
  const { classes } = useStyles();

  const [isImageError, setIsImageError] = useState(false);

  const handleImageError = () => {
    setIsImageError(true);
  };

  if (quizType === QuizType.QuestionAnswer) {
    const scorePercentage = getScorePercentage(description);
    const qaThumbnail = getScoreThumbnail(scorePercentage);

    return (
      <div className={classes.container}>
        <img
          src={qaThumbnail.src}
          alt="score thumbnail"
          className={classes.qaThumbnail}
        />
        <Watermark className={classes.watermark} />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      {spotifyUrl && <SpotifyWidget url={spotifyUrl} />}
      {thumbnail && !spotifyUrl && (
        <div className={classes.resultThumbnailContainer}>
          {!isImageError &&
            (isBusiness ? (
              <a href={productPageUrl}>
                <img
                  src={thumbnail}
                  alt={title}
                  className={classes.resultThumbnail}
                  onError={handleImageError}
                />
              </a>
            ) : (
              <img
                src={thumbnail}
                alt={title}
                className={classes.resultThumbnail}
              />
            ))}
          {thumbnail.includes("media.tenor") && (
            <div className={classes.tenorAttributionLogoContainer}>
              <img
                src="https://www.gstatic.com/tenor/web/attribution/via_tenor_logo_blue.svg"
                alt="via Tenor"
                className={classes.tenorAttributionLogo}
              />
            </div>
          )}
        </div>
      )}
      {!isImageError && <Watermark className={classes.watermark} />}
    </div>
  );
};

export default QuizResultThumbnail;
